module.exports = __webpack_public_path__ + "img/IMG_0311.f7e7aed5.png";